/**
 * 交易時段
 */
export var SessionType;
(function (SessionType) {
    SessionType[SessionType["TWSE"] = 0] = "TWSE";
    SessionType[SessionType["TAIFEX"] = 1] = "TAIFEX";
    SessionType[SessionType["TAIFEX_AM"] = 2] = "TAIFEX_AM";
})(SessionType || (SessionType = {}));
